import { ChevronDown } from "lucide-react";
import { forwardRef } from "react";

type CardWrapperProps = {
    title: string;
    isOpen: boolean;
    onClick: () => void;
    children: React.ReactNode;
};

const CardWrapper = forwardRef<HTMLDivElement, CardWrapperProps>(
    ({ title, isOpen, onClick, children }, ref) => {
        return (
            <div className="bg-white rounded-xl mb-4 border border-[#A8D97B]/40 overflow-visible">

                {/* HEADER */}
                <div
                    ref={ref}
                    className="flex justify-between items-center px-4 py-2.5  cursor-pointer"
                    onClick={onClick}
                >
                    <h2 className="text-lg font-semibold text-[#2F5E2E]">{title}</h2>
                    <ChevronDown
                        className={`transition-transform duration-300 ${isOpen ? "rotate-180" : ""
                            }`}
                    />
                </div>

                {/* BODY */}
                {isOpen && (
                    <div className="p-4 border-t">
                        {children}
                    </div>
                )}
            </div>
        )
    }
);

export default CardWrapper